/* Layout */
import Layout from '../../views/layout/Layout.vue'

const ProductCategorize = () => import(/* webpackChunkName: "product-categorize" */ '@/views/product/categorize')
const RemoveProduct = () => import(/* webpackChunkName: "product-categorize" */ '@/views/product-cat/remove-products.vue')

export default [
  {
    path: '/product-cat',
    component: Layout,
    redirect: 'noredirect',
    name: 'Product Categorization',
    alwaysShow: true,
    meta: {
      title: 'productCat',
      icon: 'tshirt',
    },
    children: [
      {
        path: 'categorize',
        component: ProductCategorize,
        name: 'ProductCategorize',
        meta: {
          title: 'Update Category',
          accessibleName: 'product-categorization',
        },
      },
      {
        path: 'removeproduct',
        component: RemoveProduct,
        name: 'RemoveProduct',
        meta: {
          title: 'Remove Product',
          accessibleName: 'remove-product',
        },
      },
    ],
  },
]
